<template>
    <component :is="external ? 'a' : Link" v-bind="anchorAttributes" :href="props.link" class="article-card" :aria-label="props.headline">
        <img class="article-card__image" :src="articleImg" :alt="props.headline" loading="lazy"/>
        <div class="article-card__content bg-rothcoCream">
            <div class="article-card__type">
                <p v-if="props.subject">{{ props.subject }}</p>
                <p v-if="props.date">{{ props.date }}</p>
            </div>
            <p class="article-card__title title-s text-rothcoBlack" v-if="props.headline">{{ props.headline }}</p>
            <span class="article-card__action paragraph-default" v-if="props.cta">{{ props.cta }}</span>
        </div>
    </component>
</template>
<script lang="ts" setup>
    import { Link } from "@inertiajs/vue3"
    import { computed } from "vue";
    import useImageOptization from "@composables/useImageOptimization";
    import { comingSoonImages } from "@/helpers/composables/comingSoonImages";
    let props = defineProps({
        subject: {
            type: String,
            default: ""
        },
        date: {
            type: String,
            default: ""
        },
        headline: {
            type: String,
            default: ""
        },
        image: {
            type: String,
            default: ""
        },
        cta: {
            type: String,
            default: ""
        },
        link: {
            type: String,
            default: "#",
        },
        external: {
            type: Boolean,
            default: false
        }
    });

    let anchorAttributes = computed(() => {
        return props.external ? { target: "_blank", } : {};
    });

    let { optimizedImageUrl } = useImageOptization(props.image);

    let articleImg = computed(()=>{
        return props.image ? optimizedImageUrl.value : comingSoonImages().large;
    })
</script>